import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const SeedMIS = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    const Datelst = [
      {
        name: "Farmers Enrollment Template",
        reportUrl: "/farmersEnrollmentTemplate",
        icon: "fa-user-plus",
      },
      {
        name: "Plot Mapping",
        reportUrl: "/plotMapping",
        icon: "fa-map-marked-alt",
      },
      {
        name: "Farmer Bank Detail",
        reportUrl: "/farmerBankDetailreport",
        icon: "fa-university",
      },
      {
        name: "Sowing Detail Report",
        reportUrl: "/fmancropsowingdetail",
        icon: "fa-seedling",
      },
      {
        name: "Inputs Distribution to Subsidairy Warehouse(Field Agent)",
        reportUrl: "/inputsdistributionfromwarehousereport",
        icon: "fa-truck-loading",
      },
      {
        name: "Goods Issued Detail",
        reportUrl: "/farmergoodsissuefmndetail",
        icon: "fa-dolly",
      },
      {
        name: "Goods Productwise Issued Detail",
        reportUrl: "/farmerproductwisegoodsissuedetailfmn",
        icon: "fa-boxes",
      },
      {
        name: "Procurement Report",
        reportUrl: "/procurementReport",
        icon: "fa-file-invoice-dollar",
      },
      {
        name: "Farmer Training Report",
        reportUrl: "/farmerTrainingReport",
        icon: "fa-chalkboard-teacher",
      },
      {
        name: "Farmer Survey Report",
        reportUrl: "/farmerSurveyReport",
        icon: "fa-poll",
      },
      {
        name: "Agent Call Service",
        reportUrl: "/agentCallService",
        icon: "fa-headset",
      },
      {
        name: "Warehouse Stock Info Report",
        reportUrl: "/warehousestockinforeport",
        icon: "fa-warehouse",
      },
      { name: "Crop Cut Report", reportUrl: "/cropcutreport", icon: "fa-cut" },
      {
        name: "Farmer Inspection Report",
        reportUrl: "/farmerinspectionreport",
        icon: "fa-search",
      },
      {
        name: "Goods Issue",
        reportUrl: "/farmerGoodsIssueProductReportFMN",
        icon: "fa-dolly-flatbed",
      }
      ,
      {
        name: "Agronomy Record",
        reportUrl: "/maizeDataCaptureReport",
        icon: "fa-book",
      },
      
      // {
      //   name: "Fertilizer Trial (A)",
      //   reportUrl: "/DrySeasonFertilizerReprot",
      //   icon: "fa-cloud-sun",
      // },
      // {
      //   name: "Fertilizer Trial (B)",
      //   reportUrl: "/DemoFertilizerTrialReport",
      //   icon: "fa-flask",
      // },
      // {
      //   name: "Brazil Hybrid Maize Reprot",
      //   reportUrl: "/BrazilHybridMaizeReport",
      //   icon: "fa-seedling",
      // },
      // {
      //   name: "Maize and Sorghum TRIALS Report",
      //   reportUrl: "/MaizeandSorghumTRIALSReport",
      //   icon: "fa-tractor",
      // },
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const colors = [
    "#00bcd4",
    "#4caf50",
    "#ff9800",
    "#e91e63",
    "#9c27b0",
    "#2196f3",
    "#795548",
    "#03a9f4",
    "#8bc34a",
    "#f44336",
    "#607d8b",
    "#673ab7",
    "#009688",
    "#ff5722",
    "#3f51b5",
    "#c2185b",
    "#0097a7",
    "#afb42b",
    "#5d4037",
  ];

  return (
    <div className="content-wrapper p-4">
      <h4 className="mb-4 text-primary">📋 Seed Production Report Dashboard</h4>

      <div className="row">
        {datelist.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
                style={{
                  borderLeft: `10px solid ${colors[index % colors.length]}`,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">
                  {item.name}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 15px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};

export default SeedMIS;
